/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React, { type ReactNode } from 'react';

import { ListeTable, ListeTableContainer } from '@mairistem/liste';

import type { MentionActe } from '@/types';

import MentionListeTableRow from './MentionListeTableRow';

interface MentionListeTableProps {
  items?: Array<Partial<MentionActe>>;
  count?: number;
  perPage?: number;
  loading?: boolean;
  onLoad?: any;
  onSort?: any;
  onEdit: (mention: Partial<MentionActe>) => void;
  onDelete: (mention: Partial<MentionActe>) => void;
}

const MentionListeTable = (props: MentionListeTableProps) => {
  const { items, count, perPage, loading, onLoad, onSort, onEdit, onDelete } =
    props;

  const listItems = React.useMemo(() => items ?? [], [items]);

  const renderRow = (item: Partial<MentionActe>, invalidate: () => void) => (
    <MentionListeTableRow
      item={item}
      invalidate={invalidate}
      onEdit={onEdit}
      onDelete={onDelete}
    />
  );

  /*
   * ⚠️ Les colonnes doivent être les enfants DIRECTS de `ListeTable.Header` :
   * la lib leur injecte `onSort` en rendant ses enfants immédiats. Dans un
   * fragment, c'est le fragment qui le recevait, et le clic sur une colonne
   * « triable » ne déclenchait aucune requête.
   */
  const renderHeader = React.useMemo(
    () => (
      <ListeTable.Header>
        <ListeTable.Column name="numero" sortable width={1}>
          N°
        </ListeTable.Column>
        <ListeTable.Column name="dateApposition" sortable width={1}>
          Apposition
        </ListeTable.Column>
        <ListeTable.Column name="titre" sortable width={5}>
          Libellé
        </ListeTable.Column>
        <ListeTable.Column name="texte" sortable width={6}>
          Texte
        </ListeTable.Column>
        <ListeTable.Column name="codeMentionAnts" sortable width={2}>
          Code ANTS
        </ListeTable.Column>
        <ListeTable.Column name="actions" />
      </ListeTable.Header>
    ),
    [],
  );

  return (
    <ListeTableContainer
      // @ts-ignore
      items={listItems}
    >
      <ListeTable
        items={listItems}
        virtual={false}
        loading={loading}
        perPage={perPage}
        count={count}
        onLoad={onLoad}
        onSort={onSort}
        noResultsIcon="search"
        noResultsMessage="Aucune mention"
      >
        {renderHeader}
        {renderRow as unknown as ReactNode}
      </ListeTable>
    </ListeTableContainer>
  );
};

export default MentionListeTable;
